export default "__VITE_ASSET__CucMLCRX__"